/* SHARED VARS */
var firstrun = true,
    liveEffects = ['fade','scale'],
    liveEasing = 'smooth',
    liveSpeed = 500,
    touch = false,
    list = false,
    clickEv = 'click';

/* SANDBOX */
function mixSandBox(){
  
  // INSTANTIATE MIXITUP ON SANDBOX
  
  if($('#sandBox').length)
  $('#sandBox').mixitup({
    buttonEvent: clickEv,
    onMixStart: function(config){
      
      // PAUSE LOGO ON SANDBOX ACTIVITY
      if(typeof timer != 'undefined'){
        clearInterval(timer);
      };
      if(typeof counter != 'undefined'){
        clearInterval(counter);
      };
      
      // UPDATE EFFECTS LIST
      config.effects = liveEffects;
      
      // UPDATE EASING
      config.easing = liveEasing;
      
      // UPDATE SPEED
      config.transitionSpeed = liveSpeed;
      
      return config;
    },
    onMixEnd: function(config){
      
      // ADD LIST STYING
      var wait = setTimeout(function(){
        if(config.layoutMode == 'list'){
          list = true;
        };
        
        sortSandBox();
      },100);
    }
  });
}

function sortSandBox(){
  var listSB = $('#sandBox .item');
  listSB.removeClass('first');
  $("#sandBox .item:nth-child(4n)").addClass('first');
}

var isMobile = {
    Android: function() {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function() {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function() {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function() {
        return navigator.userAgent.match(/IEMobile/i);
    },
    any: function() {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
    }
};

/* Fucntion get width browser */
function getWidthBrowser() {
	var myWidth;

	if( typeof( window.innerWidth ) == 'number' ) { 
		//Non-IE 
		myWidth = window.innerWidth;
		//myHeight = window.innerHeight; 
	} 
	else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) { 
		//IE 6+ in 'standards compliant mode' 
		myWidth = document.documentElement.clientWidth; 
		//myHeight = document.documentElement.clientHeight; 
	} 
	else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) { 
		//IE 4 compatible 
		myWidth = document.body.clientWidth; 
		//myHeight = document.body.clientHeight; 
	}
	
	return myWidth;
}

// handles Animate
function dataAnimate(){
  $('[data-animate]').each(function(){
    
    var $toAnimateElement = $(this);
    
    var toAnimateDelay = $(this).attr('data-delay');
    
    var toAnimateDelayTime = 0;
    
    if( toAnimateDelay ) { toAnimateDelayTime = Number( toAnimateDelay ); } else { toAnimateDelayTime = 200; }
    
    if( !$toAnimateElement.hasClass('animated') ) {
      
      $toAnimateElement.addClass('not-animated');
      
      var elementAnimation = $toAnimateElement.attr('data-animate');
      
      $toAnimateElement.appear(function () {
        
        setTimeout(function() {
          $toAnimateElement.removeClass('not-animated').addClass( elementAnimation + ' animated');
        }, toAnimateDelayTime);
        
      },{accX: 0, accY: -80},'easeInCubic');
      
    }
    
  });
}

/* Refresh CloudZoom */
function updateCloudZoom(){
  $('#wrap').find('.mousetrap').remove();
  if(touch == false){
    
    $('.cloud-zoom, .cloud-zoom-gallery').CloudZoom({position: 'inside'});
    
  }
}
    
function handleFocus(){
  $(".form-focus input").focus(function() {
    $(this).parents('.form-focus').addClass('focus');
  }).blur(function() {
    $(this).parents('.form-focus').removeClass('focus');
  });
}
    
function handleLogin(){
  $("#loginBox input").focus(function() {
    $(this).parents('#loginBox').addClass('focus');
  }).blur(function() {
    $(this).parents('#loginBox').removeClass('focus');
  });
}

$(window).resize(function() {
  
  if(getWidthBrowser() == 320){
    $('body').css('max-width', '300px');
  }
  else{
    $('body').css('max-width', '');
  }
  
  updateCloudZoom();
  
});

jQuery(document).ready(function($) {
  
  
  /* DETECT PLATFORM */
  $.support.touch = 'ontouchend' in document;
  
  if ($.support.touch) {
    touch = true;
    $('body').addClass('touch');
    $('body img').removeClass('animation');
    clickEv = 'touchstart';
  }
  else{
    $('body').addClass('notouch');
    if (navigator.appVersion.indexOf("Mac")!=-1){
      if (navigator.userAgent.indexOf("Safari") > -1){
        $('body').addClass('macos');
      }
      else if (navigator.userAgent.indexOf("Chrome") > -1){
        $('body').addClass('macos-chrome');
      }
        else if (navigator.userAgent.indexOf("Mozilla") > -1){
          $('body').addClass('macos-mozilla');
        }
    }
  }
  
  /* Handle Animate */
  if(touch == false){
    dataAnimate();
  }
  
  /* Handle focus input */
  handleFocus();
  handleLogin();
  
  $('.dropdown-menu').on(clickEv, function (e) {
    e.stopPropagation();
  });
  $('.dropdown-menu').on('click', function (e) {
    e.stopPropagation();
  });
  $('.btn-navbar').on('click', function() {
    
    /*++*/
//     if ($('.site-logo').is(':visible')) $('.site-logo').css('opacity','0');//toggleClass('slideLeft');
//     else $('.site-logo').css('opacity','1');
    
    $('body, html').toggleClass('overflow-hidden');
    $('ul.nav li.slideLeft').removeClass('slideLeft');
    /*++*/
    
    return true;
  });
  
  $(".dropdown-toggle").parent().hover(function (){
    if(touch == false && getWidthBrowser() > 768 ){
      $(this).find('div.dropdown-menu').stop(true, true).slideDown(300, function() {
        if ($(this).hasClass('list-styled')) this.style.display = 'flex';
      });
    }
  }, function (){
    if(touch == false && getWidthBrowser() > 768 ){
      $(this).find('div.dropdown-menu').hide();
    }
  });
  
  /*++*/
  $('a.hoverBorder').click(e => { /* When a product image is clicked on from mobile, do not link to the product, but show the hover effect - JDH */
    if(touch == true || getWidthBrowser() < 768) {
      $(this).hover();
      try {
// console.log(e.target.tagName,e);
      } catch(err) { console.error(400,err); }
      
      if ($(e.target).hasClass('hoverBorder')) return false;
    }
  });
  
  $('ul.nav.hoverMenuWrapper li.dropdown').on('click', function() {
    $(this).siblings().toggleClass('slideLeft');
  });
  /*++*/
  
  $('.dropdown-link').on('click', function() {
    if(touch == false && getWidthBrowser() > 768 ){
      var href = $(this).attr('href');
      window.location = href;
    }
    else {
      
      
//       if (
//         $('
//       }
      
      
//       if (!$(this).parent().hasClass('open')) {
//         console.log(1,this,'touch action');/*++*/
        
//         $(this).parent().siblings('li').animate({
//           opacity: 'hide', // animate slideUp
//           right: '200px',  // slide left
//         }, 'slow', 'linear', function() {
// //           $(this).hide();
//         });
//         $(this).parent().siblings('li').not($(this).parent()).slideUp();/*++++*/
//       }
//       else {
//         $(this).parent().siblings('li').animate({
//           opacity: 'show', // animate slideUp
//           right: '0',  // slide left
//         }, 'slow', 'linear', function() {
// //           $(this).show();
//         });
//       }
//      $(this).parent().siblings('li:not(.open)').slideDown();/*++++*/
    }
//     else {
//           console.log(2,this,'unknown touch click');

//     }
  });
  
  if (getWidthBrowser() < 768) { /* Keep the cart icon in-position on mobile */
    var navHeight = $('.nav-collapse.collapse').height();
    
    $('#umbrella').css('top', navHeight + 55);
    
    $(window).on('scroll', function() {
      $('#umbrella').css('top', navHeight - $(this).scrollTop() + 55);
    })
  }
  
  
  
  $('#collection_tags').on('change', function() {
    window.location = $(this).val();
  });
  
  if($("img.unveil").length){
    $("img.unveil").unveil(300);
  }
  
  /* Product image */
  
  $(".fancybox").fancybox({
    'hideOnContentClick': true,
    openEffect  : 'none',
    closeEffect : 'none',
    padding: 0
  });
  
   
  
  updateCloudZoom();
  
   
  $('.product-image').on(clickEv, '#wrap', function() {
    if(touch == false){
      $('.cloud-zoom-lens').remove();
      $('#cloud-zoom-big').remove();
      $('.product-thumb').find('.thumb-zoom.active').find('.fancybox').click();
    }
    else{
      $('#wrap').find('.mousetrap').remove();
      if(getWidthBrowser() < 768){
        return false;
      }
    }
  });
   
   $('.product-image').on(clickEv, '.main-image', function() {
     //return false;
   });
  
  $('.product-image').on(clickEv, '.thumb-zoom', function() {
    
    var $this = $(this);
    var parent = $this.parents('.product-image');
    var child = $this.find('img');
    var src_original = child.attr('data-src-original');
    var src_display = child.attr('data-src-display');
    
    parent.find('.thumb-zoom').removeClass('active');
    $this.addClass('active');
    
    parent.find('.main-image').attr('href', src_original);
    parent.find('.main-image').find('img').attr('src', src_display);
    
    updateCloudZoom();
    
    if(touch == true){
      return false;
    }
    
  }).on('hover', '.thumb-zoom', function() {
    var $this = $(this);
    var parent = $this.parents('.product-image');
    var child = $this.find('img');
    var src_original = child.attr('data-src-original');
    var src_display = child.attr('data-src-display');
    
    parent.find('.thumb-zoom').removeClass('active');
    $this.addClass('active');
    
    parent.find('.main-image').attr('href', src_original);
    parent.find('.main-image').find('img').attr('src', src_display);
    
    updateCloudZoom();
  });
  
  /* Quantity */
  $('.quantity-wrapper').on(clickEv, '.qty-up', function() {
    var $this = $(this);
    
    var qty = $this.data('src');
    $(qty).val(parseInt($(qty).val()) + 1);
  });
  $('.quantity-wrapper').on(clickEv, '.qty-down', function() {
    var $this = $(this);
    
    var qty = $this.data('src');
    
    if(parseInt($(qty).val()) > 1)
    	$(qty).val(parseInt($(qty).val()) - 1);
  });

  
  /* Tooltip */
  $('.btooltip').tooltip();
  
  
  

  /* INSTANTIATE SANDBOX */
  mixSandBox();
  
  /* Sort by */
  /*----@@@@$('#sortForm li.sort').click(function(){  // add event any time the sort box changes
    
    var button = $('#sortButton');
    var box = $('#sortBox');
    
    $('#sortButton .name').html($(this).html());
    
    button.removeClass('active');
    box.hide();
    
    if(touch == false){
      var that = $("#sandBox");
      var items = that.find('.not-animated');
      items.removeClass('not-animated').unbind('appear');
      
      items = that.find('.animated');
      items.removeClass('animated').unbind('appear');
    }
  });*/
  
  /*----sortbyPopup();
  function sortbyPopup(){
    var warper = $('#sortButtonWarper');
    var button = $('#sortButton');
    var box = $('#sortBox');
    var form = $('#sortBox #sortForm');
    button.click(function(sort) {
      box.toggle();
      button.toggleClass('active');
    });
    form.mouseup(function() { 
      return false;
    });
    $(this).mouseup(function(sort) {
      if(!($(sort.target).parent('#sortButton').length > 0)) {
        button.removeClass('active');
        box.hide();
      }
    });
  }----*/
  customDropdown();
  function customDropdown(){
    $('.dropdown-btn').click(function(sort) {
      $(this).next('.dropdown-box').toggle();
      $(this).toggleClass('active');
    });
    
    $('.dropdown-box ul').mouseup(function() { 
      return false;
    });
    $(this).mouseup(function(sort) {
      if(!($(sort.target).parent('.dropdown-btn').length > 0)) {
        $('.dropdown-btn').removeClass('active');
        $('.dropdown-box').hide();
      }
    });
  }
  
  /* GRID/LIST */
  
  $('#goList').on(clickEv, function(e){
    $(this).parent().find('li').removeClass('active');
    $(this).addClass('active');
    
    $('#sandBox .mix').addClass('full_width');
    $('#sandBox .mix .row-left').addClass('span4');
    $('#sandBox .mix .row-right').addClass('span8');
    
    $('#sandBox').mixitup('toList');
  });
  
  $('#goGrid').on(clickEv, function(e){
    $(this).parent().find('li').removeClass('active');
    $(this).addClass('active');
    
    $('#sandBox .mix').removeClass('full_width');
    $('#sandBox .mix .row-left').removeClass('span4');
    $('#sandBox .mix .row-right').removeClass('span8');
    
    $('#sandBox').mixitup('toGrid');
  });
});
/*&*/